import naja from "naja";
import Form from './Form';

export default class OrderPerson {

    static init() {
        this.initEmailInput();
        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet-orderPersonForm-emailForms') {
                Form.handleFixedLabel();
                OrderPerson.initEmailInput();
            }
        });
    }

    static initEmailInput() {
        let typingTimer;
        let typingInterval = 1200;

        let that = this;

        const input = document.getElementById('emailOrderInput');

        if (input) {

            input.addEventListener('keydown', function(e) {
                if(e.keyCode === 9) {
                    e.preventDefault();
                    document.getElementById('personContactPhone').focus();
                    that.doneTypingEmail();
                }
                clearTimeout(typingTimer);
            });
            input.addEventListener('keyup', function(e) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(that.doneTypingEmail, typingInterval);
            });
            input.addEventListener('change', function() {
                that.doneTypingEmail();
            });
        }
    }

    static doneTypingEmail() {
        const input = document.getElementById('emailOrderInput');
        const form = document.getElementById('frm-orderPersonForm-emailForm');

        if(input) {
            if(input.checkValidity() === true) {
                naja.uiHandler.submitForm(form);
            }
        }
    }
}
